module.exports = __webpack_public_path__ + "img/hr-heatex-N-idle.bc65a137.png";